import React from 'react';
import PropTypes from 'prop-types';
import { SelectionMode, DetailsHeader } from 'office-ui-fabric-react';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { MessageBar } from 'office-ui-fabric-react/lib/MessageBar';
import { DetailsList, DetailsRow } from 'office-ui-fabric-react/lib/DetailsList';
import { allColumns } from '../DynamicDetailsList/ContractTransactionColumns';
import { recoupmentPercentColumnAsListItem } from '../DynamicDetailsList/recoupmentColumns';
import {
  effectiveDateColumnListItem,
  expirationDateColumnListItem,
} from '../DynamicDetailsList/DateColumns';
import styles from './AdvanceGroupAssignmentDetails.style';

const AdvanceGroupAssignmentDetails = ({ groupAssignments }) => {
  const getFiltersDetailListItems = assignment => {
    const normalizedFilters = assignment.filters.map((filter, index) => {
      const percentageParam = filter.recoupmentParams.find(param => {
        return param.property === 'recoupmentPercentage';
      });

      const filterRow = { ...filter };

      // Adding each property inside dimensions array to filter attribute, so that detailList can get the value from column's fieldName
      assignment.dimensions.forEach(dimension => {
        if (filter && filter.dimensions?.length > 0) {
          filter.dimensions.forEach(filterDimension => {
            if (filterDimension && filterDimension.property === dimension) {
              filterRow[dimension] = filterDimension.text
                ? filterDimension.text
                : filterDimension.value;
            }
          });
        }

        if (!filterRow[dimension]) {
          filterRow[dimension] = 'Any';
        }
      });

      return {
        key: index.toString(),
        recoupmentPercentage: percentageParam.value,
        ...filterRow,
      };
    });
    return normalizedFilters;
  };

  const getGroupAssignmentColumns = assignment => {
    const dimensionsColumns = assignment.dimensions.map(dimension => {
      const columnName = allColumns.find(x => x.key === dimension).name;
      return {
        key: dimension,
        name: columnName,
        isResizable: false,
        minWidth: 200,
        maxWidth: 200,
        data: 'string',
        fieldName: dimension,
      };
    });

    return [
      recoupmentPercentColumnAsListItem(),
      ...dimensionsColumns,
      effectiveDateColumnListItem(),
      expirationDateColumnListItem(),
    ];
  };

  return groupAssignments?.filters && groupAssignments?.filters.length > 0 ? (
    <>
      <div data-testid="groupAssignmentDetailsList">
        <DetailsList
          items={getFiltersDetailListItems(groupAssignments)}
          columns={getGroupAssignmentColumns(groupAssignments)}
          selectionMode={SelectionMode.none}
          isHeaderVisible
          onRenderDetailsHeader={props => (
            <DetailsHeader className={styles.primaryBottomBorder} {...props} />
          )}
          onRenderRow={props => <DetailsRow {...props} className={styles.transparentBackground} />}
        />
      </div>
    </>
  ) : (
    <>
      <MessageBar data-testid="noAssignmentMessageBar">
        <Text as="p" block className={styles.messageBarBody}>
          No assignments currently added to this group. Select the Add Assignment button below to
          create an assignment.
        </Text>
      </MessageBar>
    </>
  );
};

AdvanceGroupAssignmentDetails.propTypes = {
  groupAssignments: PropTypes.object.isRequired,
};

export default AdvanceGroupAssignmentDetails;
